import { createTheme, Theme } from "@mui/material";
import autocomplete from "@themes:overrides/autocomplete";
import button from "@themes:overrides/button";
import datagrid from "@themes:overrides/datagrid";
import select from "@themes:overrides/select";
import table from "@themes:overrides/table";
import textField from "@themes:overrides/textField";
import toggleButton from "@themes:overrides/toggleButton";
import toggleButtonGroup from "@themes:overrides/toggleButtonGroup";
import { adjustBrightness } from "@utils:color";

import defaultPalette from "@:themes/palette";
import typography from "@:themes/typography";

// Component overrides shared by all themes
const componentOverrides = {
  ...button,
  ...textField,
  ...select,
  ...table,
  ...autocomplete,
  ...toggleButtonGroup,
  ...toggleButton,
  ...datagrid,
};

// Default theme export (for initial render before branding loads)
export const themes = createTheme(
  {
    palette: defaultPalette,
    typography,
  },
  {
    components: componentOverrides,
  },
);

// Create theme with custom branding colors
export const createBrandedTheme = (
  primaryColor?: string | null,
  secondaryColor?: string | null,
  sidebarColor?: string | null,
  backgroundColor?: string | null,
): Theme => {
  const customPalette = {
    ...defaultPalette,
    ...(primaryColor && {
      primary: {
        main: primaryColor,
        light: adjustBrightness(primaryColor, 40),
        dark: adjustBrightness(primaryColor, -40),
        contrastText: defaultPalette.primary.contrastText,
      },
    }),
    ...(secondaryColor && {
      secondary: {
        main: secondaryColor,
        light: adjustBrightness(secondaryColor, 40),
        dark: adjustBrightness(secondaryColor, -40),
      },
    }),
    background: {
      ...defaultPalette.background,
      ...(sidebarColor && { sidebar: sidebarColor }),
      ...(backgroundColor && { default: backgroundColor }),
    },
  };

  return createTheme(
    {
      palette: customPalette,
      typography,
    },
    {
      components: componentOverrides,
    },
  );
};
